import React from 'react';
import { useNavigate, Link, useParams } from "react-router-dom";
import { useFormInputValidation } from "react-form-input-validation";
import { useState } from 'react';

import './home.css';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Pagination from 'react-bootstrap/Pagination';

import { IoEyeOutline } from "react-icons/io5";
import InputGroup from 'react-bootstrap/InputGroup';
import Form from 'react-bootstrap/Form';

import { FaGoogle } from "react-icons/fa";

import Card from 'react-bootstrap/Card';

import Header from '../../components/header/header';
import Footer from '../../components/footer/footer';
import {connect} from 'react-redux';
import * as actions from '../../store/customer/actions';

let active = 2;
let items = [];
for (let number = 1; number <= 5; number++) {
  items.push(
    <Pagination.Item key={number} active={number === active}>
      {number}
    </Pagination.Item>,
  );
}

const ResetPassswordPage = ({resetPassword}) => {  
    const navigate = useNavigate();
    let match = useParams("/reset-password/:token");
    const [ errors, setErrors ] = useState({})
    const [processing, setProcessing] = useState(false);
    const [resetErr , setResetErr ] = useState();
    const [showNewPass, setShowNewPass] = useState(false);
    const [newPasswordType, setNewPasswordType] = useState('password');
    const [showRepeatPass, setShowRepeatPass] = useState(false);
    const [repeatPasswordType, setRepeatPasswordType] = useState('password');
    const[ successMessage, setSuccessMessage ] = useState();
    const[ hasSubmit, setHasSubmit ] = useState();
    const [formData, setFormData] = useState({
        password: '',
        confirm_password: ''
    });
    const [validated, setValidated] = useState(false);
  
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
        const newErrors = findFormErrors();
        if(hasSubmit){
            setErrors(newErrors)
        }
        setResetErr('')
    }
    
    const showNewPassword = () => {
        if(!showNewPass){
            setNewPasswordType('text');
          } else {
            setNewPasswordType('password');
          }
          setShowNewPass(!showNewPass);
    }
    const showRepeatPassword = () => {
        if(!showRepeatPass){
            setRepeatPasswordType('text');
          } else {
            setRepeatPasswordType('password');
          }
          setShowRepeatPass(!showRepeatPass);
    }

    const findFormErrors = () => {
        const { password, confirm_password, } = formData
        const newErrors = {}
        
        // password errors
        if ( !password || password === '' ) newErrors.password = 'Password cannot be blank!'
        // confirm password errors
        if ( !confirm_password || confirm_password === '' ) newErrors.confirm_password = 'Confirm password cannot be blank!'
        else if ( confirm_password != password ) newErrors.confirm_password = 'Password mismatch'
        return newErrors
    }

    const handleSubmit = (event) => {
        const newErrors = findFormErrors();
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();
        setHasSubmit(true);
        if ( Object.keys(newErrors).length > 0 ) {
        //   console.log(newErrors)
          // We got errors!
          setErrors(newErrors)
        } else {
          resetPasswordRequest(formData);
        }
    }

    const resetPasswordRequest = async(post) => {
        setProcessing(true);
        post.email = match.email;
        post.token = match.token;
        resetPassword(post).then(res => {
        
            if(res.payload.response && res.payload.response.status === 401){
                setResetErr(res.payload.response.data.message);
            } else if(res.payload.response && res.payload.response.status === 500){
                setResetErr(res.payload.response.data.message.message);
            } else if(res.payload.data) {
                setSuccessMessage('Password changed successfully.');
                setTimeout(
                    () => resetSuccessMessage(), 
                    3000
                );
            }
            setProcessing(false);
        });
    }

    const resetSuccessMessage = () => {
        window.location.href= "/signin";
    }

    return (
        <div>
            <Header/>
            <section className='pt-5 pb-5 bg-dark'>
                <h3 className='text-center'>Sign Up</h3>
            </section>
            <section className='pt-5 pb-5'>
                <Container>
                    <Row className='justify-content-center'>
                        <Col xs={6}>
                            <Card className='shadow p-4'>
                                <Card.Body>
                                    <h2 className='text-center'>Forget Password</h2>
                                    
                                    <form className='mt-4' noValidate onSubmit={handleSubmit}>
                                        <div class="form-group">
                                            <Form.Label className="text-5">New Password</Form.Label>
                                            <InputGroup className="input-pass" controlid="formNewPassword" >
                                                <Form.Control type={newPasswordType} placeholder="New Password" name="password"  onChange={handleChange} isInvalid={ !!errors.password } autocomplete="off" />
                                                <InputGroup.Text>
                                                    {/* <i onClick={showNewPassword} class={ showNewPass ? 'lnir lnir-eye' : 'lnir lnir-eye strike'}></i> */}
                                                    <svg onClick={showNewPassword} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M2.80658 7.06992C6.03344 1.64336 13.9666 1.64336 17.1934 7.06992C18.2689 8.87846 18.2689 11.1215 17.1934 12.9301C13.9666 18.3566 6.03344 18.3566 2.80658 12.9301C1.73114 11.1215 1.73114 8.87846 2.80658 7.06992Z" stroke="#D7D7D7" strokeLinecap="round" strokeLinejoin="round"/>
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M13.1615 10.0531C13.1615 11.7991 11.7455 13.2141 9.9995 13.2141C8.2535 13.2141 6.8385 11.7991 6.8385 10.0531C6.8385 8.30611 8.2535 6.89111 9.9995 6.89111C11.7455 6.89111 13.1615 8.30611 13.1615 10.0531Z" stroke="#D7D7D7" strokeLinecap="round" strokeLinejoin="round"/>
                                                        { showNewPass ? '' : <path d="M17.5 3L2 17" stroke="#D7D7D7" strokeLinecap="round"/> }
                                                    </svg>
                                                </InputGroup.Text>
                                            </InputGroup>
                                            <Form.Control.Feedback type="invalid">
                                                { errors.password }
                                            </Form.Control.Feedback>
                                        </div>
                                        <div class="form-group">
                                            <Form.Label className="text-5">Confirm Password</Form.Label>
                                            <InputGroup className="input-pass" controlid="formConfirmPassword" >
                                                
                                                <Form.Control type={repeatPasswordType} placeholder="Confirm Password" name="confirm_password"  onChange={handleChange} isInvalid={ !!errors.confirm_password } autocomplete="off" />
                                                <InputGroup.Text>
                                                    {/* <i onClick={showRepeatPassword} class={ showRepeatPass ? 'lnir lnir-eye' : 'lnir lnir-eye strike'}></i> */}
                                                    <svg onClick={showRepeatPassword} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M2.80658 7.06992C6.03344 1.64336 13.9666 1.64336 17.1934 7.06992C18.2689 8.87846 18.2689 11.1215 17.1934 12.9301C13.9666 18.3566 6.03344 18.3566 2.80658 12.9301C1.73114 11.1215 1.73114 8.87846 2.80658 7.06992Z" stroke="#D7D7D7" strokeLinecap="round" strokeLinejoin="round"/>
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M13.1615 10.0531C13.1615 11.7991 11.7455 13.2141 9.9995 13.2141C8.2535 13.2141 6.8385 11.7991 6.8385 10.0531C6.8385 8.30611 8.2535 6.89111 9.9995 6.89111C11.7455 6.89111 13.1615 8.30611 13.1615 10.0531Z" stroke="#D7D7D7" strokeLinecap="round" strokeLinejoin="round"/>
                                                        { showRepeatPass ? '' : <path d="M17.5 3L2 17" stroke="#D7D7D7" strokeLinecap="round"/> }
                                                    </svg>
                                                </InputGroup.Text>
                                            </InputGroup>
                                            
                                            <Form.Control.Feedback type="invalid">
                                                { formData.password != formData.confirm_password ?  errors.confirm_password : '' }
                                            </Form.Control.Feedback>
                                        </div>
                                        <Button type="submit" className='d-block w-100 btn-lg mt-3'>Recover Password</Button>
                                        <div className='text-center mt-4'>Don’t have account? <Link to={'/signup'}>Sign Up</Link></div>
                                    </form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>
            <Footer/>
        </div>
    )
}

function mapStateToProps(state) {
    return {
      
    };
}
  
function mapDispatchToProps(dispatch) {
    return {
        resetPassword: (post) => dispatch(actions.resetPassword(post))
    };
}
  
export default connect(mapStateToProps, mapDispatchToProps)(ResetPassswordPage);